export enum VideoStatus {
  NoStatus = '',
  Pending = 'pending',
  Denied = 'denied',
  Approved = 'approved',
}
